// import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    '& .avatar-container': {
      width: 64,
      height: 64,
      borderRadius: 32,
      overflow: 'hidden',
      '& .avatar': {
        width: 64,
        objectFit: 'cover',
        height: 64,
        borderRadius: 32,
      },
    },
    '& .class': {
      background: '#ECF5F8',
      padding: '2.5px 8px 2.5px 4px',
      borderRadius: 16,
    },
  },
};

export default styles;
